import { render, staticRenderFns } from "./SurveyAttachmentList.vue?vue&type=template&id=41473578"
import script from "./SurveyAttachmentList.ts?vue&type=script&lang=ts&external"
export * from "./SurveyAttachmentList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports